<script setup lang="ts">
import SidebarCategory from '~/components/desktop/pages/news/sidebar-category.vue'
import NewsHotMatches from '~/components/desktop/pages/news/news-hot-matches.vue'
import NewsHighLight from '~/components/desktop/pages/news/news-highlight.vue'
import { useNews } from '~/composables/news/use-news'
import { useMetaStore } from '~/stores/meta.store'
import { SLUG_NEWS } from '~/constants'

const { postDetail, getNewsPostData } = useNews()
const { resetMetaStore } = useMetaStore()

await getNewsPostData()

onBeforeUnmount(resetMetaStore)
</script>
<template>
  <div class="news">
    <div class="container">
      <div class="news-detail news-content">
        <div class="page-title">
          <span class="icon-news-home"></span>
          <NuxtLink to="/">Trang chủ</NuxtLink> >
          <NuxtLink :to="`${SLUG_NEWS.PAGE}`">Tin tức</NuxtLink>
          <NuxtLink class="text-capitalize" :to="`tin-tuc?cat=${postDetail?.categories[0]?.slug}`">
            > {{ postDetail?.categories[0]?.name }}
          </NuxtLink>
          <NuxtLink v-if="postDetail?.slug" class="current-slug text-capitalize" :to="`/${postDetail.slug}.html`">
            > {{ postDetail.title }}
          </NuxtLink>
        </div>
        <div class="row">
          <div class="col-lg-3 news-content__left">
            <SidebarCategory :categorySlugCurrent="postDetail?.categories[0]?.slug" />
            <NewsHotMatches />
            <NewsHighLight />
          </div>
          <div class="col-lg-9 news-content__right">
            <div class="news-detail__content">
              <div class="news-detail__data">
                <h1 class="title-zone">{{ postDetail.title }}</h1>
                <div class="content-write" v-html="postDetail.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/news/index.scss';
@import '~scssAsset/desktop/pages/news/news-detail.scss';
</style>
